/******************
 * Vinova Themes  Framework for Prestashop 1.7.x 
 * @package    Nova - PrestaShop 1.7 Theme For Fashion Templates
 * @version    1.0
 * @author    http://vinovathemes.com/
 * @copyright  Copyright (C) October 2013 vinovathemes.com <@emai:vinovathemes@gmail.com>
 * <info@vinovathemes.com>.All rights reserved.
 * @license   GNU General Public License version 1
 * *****************/
/*
 * Custom code goes here.
 * A template should always ship with an empty custom.js
 */



    jQuery(function() {
      jQuery('.swatch :radio').change(function() {
        var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
        var optionValue = jQuery(this).val();
        jQuery(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    })
    
    $(".fancybox1").fancybox();

(function(){
  var productThemeSettings = document.querySelector('#product-theme-settings')

  if(productThemeSettings){

    // Override default values of shop.strings for each template.
    // Alternate product templates can change values of
    // add to cart button, sold out, and unavailable states here.
    theme.productStrings = {
      addToCart: JSON.parse(productThemeSettings.dataset.addtocart),
      soldOut: JSON.parse(productThemeSettings.dataset.soldout),
      unavailable: JSON.parse(productThemeSettings.dataset.unavailable)
    }

    var selectCallbackProduct = function(variant, selector) {
      novtheme.productPage({
        money_format: theme.moneyFormat,
        variant: variant,
        selector: selector
      })
    };

    new Shopify.OptionSelectors('productSelect', {
      product: JSON.parse(productThemeSettings.dataset.product),
      onVariantSelected: selectCallbackProduct,
      enableHistoryState: true
    });
    $("#AddToCartForm").unbind("submit");
    $('#AddToCart').unbind("click").click(function(e) {
      e.preventDefault();
      Shopify.addItemFromFormStart('AddToCartForm', productThemeSettings.dataset.productid);
      setTimeout(function(){
        //document.querySelector("#cart_block a").click();
        window.location.href = '/cart'
      },1000);
    })


    if (productThemeSettings.dataset.swatchenable && productThemeSettings.dataset.productavailable && productThemeSettings.dataset.optionssize > 1){
      Shopify.linkOptionSelectors(JSON.parse(productThemeSettings.dataset.product));
    }

    // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
    if (productThemeSettings.dataset.optionssize == 1 && productThemeSettings.dataset.productpptionsfirst != 'Title' ){
      $('.selector-wrapper:eq(0)').prepend('<label for="productSelect-option-0">'+productThemeSettings.dataset.productoptionsfirst+'</label>');
    }

    // Hide selectors if we only have 1 variant and its title contains 'Default'.
    if (productThemeSettings.dataset.variantssize == 1 && productThemeSettings.dataset.variansfirsttitle.includes('Default')){
      $('.selector-wrapper').hide()
    }

  }
  
  
  let buyNowButtons = document.querySelectorAll('.btnBuyNow')
  if(buyNowButtons){
    buyNowButtons.forEach( buyNowButton => {
      buyNowButton.addEventListener('click', function(e){
        e.preventDefault()
        buyNowButton.classList.add('clicked')
        var variantId = this.dataset.variant
        //clear cart, then add to cart, then redirect to cart
        let clear = {
          method: 'GET',
          headers: { 
            'Content-Type':'application/json'
          },
        }
        fetch('/cart/clear.js',clear)
        .then( data => data.json() )
        .then( response => {
          let add = {
            method: 'POST',
            headers: { 
              'Content-Type':'application/json'
            },
            body: JSON.stringify({items: [
              {
                id: variantId,
                quantity: 1
              }
            ]})
          }
          fetch('/cart/add.js', add)
          .then( data => data.json() )
          .then( response => {
            location.href = '/cart'
            buyNowButton.classList.remove('clicked')
            return true
          })
        })

        return false
      })
    })
  }
  
  let atcButtons = document.querySelectorAll('.btnAddToCartxxx')
  if(atcButtons){
    atcButtons.forEach( atcButton => {
      atcButton.addEventListener('click', function(e){
        e.preventDefault()
        atcButton.classList.add('clicked')
        var variantId = this.dataset.variant
        //then add to cart, then redirect to cart
        let clear = {
          method: 'GET',
          headers: { 
            'Content-Type':'application/json'
          },
        }
        let add = {
          method: 'POST',
          headers: { 
            'Content-Type':'application/json'
          },
          body: JSON.stringify({items: [
            {
              id: variantId,
              quantity: 1
            }
          ]})
        }
        fetch('/cart/add.js', add)
        .then( data => data.json() )
        .then( response => {
          location.href = '/cart'
          buyNowButton.classList.remove('clicked')
          return true
        })


        return false
      })
    })
  }
})()


  